<template>
  <component
    :is="$vuetify.breakpoint.xsOnly ? DialogScrollLock : MenuScrollLock"
    eager
    :content-class="`nav-menu-content prominent ${isLoaded ? '' : 'loading'}`"
    v-bind="$vuetify.breakpoint.xsOnly ? {} : {
      'max-width': '960px',
      bottom: header,
      'offset-y': header,
      left: !header,
      'offset-x': !header,
      'nudge-right': header ? 0 : 1
    }"
    :value="value && isLoaded"
    @input="v => value = v"
  >
    <!-- The activator's own listeners are deliberately not bound: the menu is opened by the click handlers below
    (see 'value'), so Vuetify doesn't also toggle it -->
    <template v-slot:activator="{ attrs }">
      <v-btn
        v-if="header"
        v-bind="attrs"
        class="header-menu font-weight-bold my-3 mx-1 px-2"
        text rounded color="ec-dark-blue"
        :disabled="disabled"
        :loading="value && !isLoaded"
        :input-value="value"
        @click="value = true"
      >
        {{name}}
        <v-icon class="mr-n1" v-html="mdiMenuDown" />
      </v-btn>
      <v-list-item
        v-else
        v-bind="attrs"
        :class="(disabled ? 'grey' : 'ec-dark-blue') + '--text header-menu'"
        :disabled="disabled"
        :input-value="value"
        @click="value = true"
      >
        <div class="relative">
          <v-icon
            class="header-menu-left hidden-xs-only"
            style="position: absolute; top: 6px; left: -14px;"
            small color="ec-dark-blue"
            v-html="mdiChevronLeft"
          />
          <v-icon :color="disabled ? 'grey' : 'ec-dark-blue'" v-html="icon" />
        </div>
        <v-list-item-title class="ml-3 text-body-2" v-html="name" />
        <v-progress-circular v-if="value && !isLoaded" indeterminate color="ec-dark-blue" size="20" width="2" />
      </v-list-item>
    </template>

    <div class="constrain" v-bind:class="{ header }">
      <template v-if="$vuetify.breakpoint.xsOnly">
        <div class="pa-3 d-flex align-center font-weight-bold">
          <div class="flex-grow-1 ec-dark-blue--text">{{name}}</div>
          <v-btn icon @click.capture.stop.prevent="value = false">
            <v-icon v-html="mdiClose" />
          </v-btn>
        </div>
        <v-divider />
      </template>
      <slot />
    </div>

  </component>
</template>


<style scoped>
.header-menu-left {
  opacity: 0;
  transition: opacity .3s;
}

@media (min-width: 600px) {
  .constrain {
    &.header {
      max-height: calc(100svh - 152px);
    }

    &:not(.header) {
      max-width: calc(100vw - 267px);
    }
  }

  .header-menu:hover,
  .header-menu.v-list-item--active {
    .header-menu-left {
      opacity: 1;
    }
  }
}


.v-btn.header-menu {
  height: unset !important;
  text-transform: none;
}

.v-btn.header-menu:not(.v-btn--active):not(:hover):focus::before,
.v-list-item.header-menu:not(.v-list-item--active):not(:hover):focus::before {
  opacity: 0;
}
</style>


<style>
.nav-menu-content {
  background: #F5F5F5EE;
  backdrop-filter: blur(18px);
  -webkit-backdrop-filter: blur(18px);

  &.loading {
    opacity: 0;
  }
}
</style>


<script>
import DialogScrollLock from '@/components/DialogScrollLock.vue';
import MenuScrollLock from '@/components/MenuScrollLock.vue';
import { mdiClose, mdiMenuDown, mdiChevronLeft } from '@mdi/js';

export default {
  name: 'nav-menu',

  props: {
    name: String,
    header: Boolean,
    disabled: Boolean,
    icon: String
  },

  data() {
    return {
      value: false,
      isLoaded: true
    };
  },

  created() {
    Object.assign(this, { DialogScrollLock, MenuScrollLock, mdiClose, mdiMenuDown, mdiChevronLeft });
  },

  watch: {
    value(v) {
      this.$emit('update:value', v);
    },

    $route() {
      this.value = false;
    }
  }
}
</script>
